import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-comparison-year',
  standalone: true,
  imports: [TranslocoPipe, CommonModule, RouterLink],
  templateUrl: './comparison-year.component.html',
  styleUrl: './comparison-year.component.css'
})
export class ComparisonYearComponent implements OnChanges {
  // Dummy data
  @Input() showDummyData: boolean = false;
  dummyyear!: number;
  dummylastFullMonthCost: number = 12.018;
  dummylastFullMonthkWh: number = 12.018;

  dummyyearToDateCost: number = 121.132;
  dummyyearToDatekWh: number = 12.018;

  dummyforecastFullYearCost: number = 428.298;
  dummyforecastFullYearkWh: number = 12.018;

  @Input() year!: number;
  @Input() lastFullMonthCost: number = 12.018;
  @Input() lastFullMonthkWh: number = 12.018;

  @Input() yearToDateCost: number = 121.132;
  @Input() yearToDatekWh: number = 12.018;

  @Input() forecastFullYearCost: number = 428.298;
  @Input() forecastFullYearkWh: number = 12.018;

  @Input() isComparisonYear: boolean = false;

  @Input() unit = "kWh";

  @Input() showUpgrade: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (this.showDummyData) {
      this.year = this.dummyyear;
      this.lastFullMonthCost = this.dummylastFullMonthCost;
      this.lastFullMonthkWh = this.dummylastFullMonthkWh;
      this.yearToDateCost = this.dummyyearToDateCost;
      this.yearToDatekWh = this.dummyyearToDatekWh;
      this.forecastFullYearCost = this.dummyforecastFullYearCost;
      this.forecastFullYearkWh = this.dummyforecastFullYearkWh;
    }
  }
}
